import { gql } from '$lib/apollo';
import { REVIEW_PRODUCT_FIELDS } from '$routes/_components/ReviewsManager/gql';

export const GET_COACHING_SESSION = gql`
  query getCoachingSession($id: UUID!) {
    coachingSession(id: $id) {
      id
      name
      state
      expiresAt
      scheduledAt
      description
      rescheduleMessage
      cancelationAmount {
        value
        currency
        subunits
      }
      sessionValue {
        value
        currency
      }
      cancelationDeadline
      canCancelWithoutFee
      reasonForCancelationFee
      coaching {
        id
        state
        isHost
        isAttendee
        hostOrAttendee
        durationSeconds
        attendee {
          id
          slug
          name
          metafyPartner
          avatar {
            original {
              url
            }
          }
          discord {
            id
            username
            discriminator
          }
        }
        host {
          id
          slug
          name
          metafyPartner
          avatar {
            original {
              url
            }
          }
          cover {
            original {
              url
            }
          }
          discord {
            id
            username
            discriminator
          }
          # testimonialRequest {
          #   id
          # }
          # testimonial {
          #   id
          # }
          sessionCancelationPolicy {
            id
            enabled
            amount
            policyType
            timeFrame
            timeUnit
          }
        }
        game {
          id
          slug
          localizedTitles {
            en
          }
          logoMain {
            original {
              url
            }
          }
          artwork {
            original {
              url
            }
          }
        }
        product {
          id
          name
          productId
          parentProduct {
            ...ReviewProductFields
          }
          productType
          price
          refundable
          description
          cover {
            original {
              url
            }
          }
          addons {
            id
            name
            price
            description
          }
          orderItem {
            id
            state
            total
            refunded {
              value
            }
          }
          policies {
            edges {
              node {
                id
                amount
                timeFrame
                timeUnit
                policyType
              }
            }
          }
          hasLeftTestimonial
        }
        sessions {
          id
        }
        sessionConnection {
          totalCount
          edges {
            node {
              id
            }
          }
        }
        intakeQuestions {
          id
          question
          answer
        }
      }
    }
  }
  ${REVIEW_PRODUCT_FIELDS}
`;

export const RESCHEDULE_COACHING_SESSION = gql`
  mutation CoachingSessionSchedule($input: CoachingSessionScheduleInput!) {
    coachingSessionSchedule(input: $input) {
      errors {
        ... on Error {
          message
        }
      }
      result {
        id
        state
      }
    }
  }
`;
